import { PUBLIC_PORTAL_HOME } from "../app/publicRoute";

const LOCAL_DEFAULTS = {
  url: "http://localhost:8081",
  realm: "ncc-local",
  clientId: "ncc-web",
} as const;

export type OidcConfig = Readonly<{
  url: string;
  realm: string;
  clientId: string;
  redirectUri: string;
  /**
   * Đích hạ cánh SAU KHI đăng xuất.
   *
   * Trỏ về cổng công khai `/` (`PUBLIC_PORTAL_HOME`) để lượt tải sau đăng xuất chạy `PublicApp`,
   * không dựng Keycloak, không cài phiên đăng nhập.
   * Giá trị này PHẢI nằm trong `post.logout.redirect.uris` của client `ncc-web`
   * (`infra/keycloak/ncc-local-realm.json`), nếu không Keycloak từ chối và trả về trang của nó.
   */
  postLogoutRedirectUri: string;
}>;

export function readOidcConfig(
  env: ImportMetaEnv,
  location: Pick<Location, "origin">,
): OidcConfig {
  return {
    url: (env.VITE_KEYCLOAK_URL ?? LOCAL_DEFAULTS.url).replace(/\/$/, ""),
    realm: env.VITE_KEYCLOAK_REALM ?? LOCAL_DEFAULTS.realm,
    clientId: env.VITE_KEYCLOAK_CLIENT_ID ?? LOCAL_DEFAULTS.clientId,
    redirectUri: `${location.origin}/`,
    postLogoutRedirectUri: `${location.origin}${PUBLIC_PORTAL_HOME}`,
  };
}